import React from 'react';
import PropTypes from 'prop-types';

import {publish} from "../api";
import {ToastService} from "../../../../components/toasts/Toasts";
import {observer} from "mobx-react"
import {PublishingDestinationSelector} from "../../PublishingDestinationSelector";
import sessionStore from "../../../../services/session/SessionStore";
import {determineDefaultSelectionForReply} from "./index";


export default observer(class Retweeter extends React.Component {

  static propTypes = {
    item: PropTypes.object.isRequired,
    onAdd: PropTypes.func,
    label: PropTypes.string
  };

  state = {
    selectedOption: undefined,
    publishing: false
  };

  render() {

    const {
      item,
      onAdd,
      label,
      ...props
    } = this.props;

    const {selectedOption, publishing} = this.state;

    const post = {
      ...item,
      scheduledResponses: item.scheduledResponses
    };
    const accountId = post ? post.accountId : (sessionStore.account.accountId || sessionStore.user.accountId);


    const alreadyReposted = {};
    let excludeOptions = [];
    const reposted = post.scheduledResponses.filter(x => x.publishType === 'Repost');
    reposted.forEach(x => {
      alreadyReposted[x.chatterUserAccountId] = true;
      excludeOptions.push({key: x.chatterUserAccountId})
    });

    const orDefault = selectedOption === 'DEFAULT' || !selectedOption  ?
      determineDefaultSelectionForReply({
        post,
        exclude: alreadyReposted
      }) : selectedOption;

    return (
      <div {...props}>
        <div style={{display: 'flex'}}>
          <div style={{flex: 1}}>
            <PublishingDestinationSelector
              width={post.provider === 'Twitter' ? '180px' : '200px'}
              excludeGroups={true}
              provider={post.provider}
              accountId={accountId}
              className="inline-select"
              selected={orDefault ? [orDefault] : []}
              onSelected={o => {
                return this.setState({selectedOption: o})
              }}
              excludeOptions={excludeOptions}
            />
          </div>
          <button
            type="button"
            style={{lineHeight: '22px', marginLeft: '5px'}}
            className="btn btn-secondary"
            disabled={!selectedOption || publishing}
            onClick={() => {
              const chatterUserAccountId = orDefault.userAccountId
                ? orDefault.userAccountId
                : orDefault.id; // Format: <PageType>:<RemoteId>
              const remotePageId = orDefault.remoteId
                ? orDefault.remoteId
                : orDefault.remoteIds[0];

              let payload = {
                provider: post.provider,
                inReplyTo: post.postId,
                chatterUserAccountId,
                remotePageId,
                publishType: 'Repost'
              };

              this.setState({publishing: true});
              return publish(payload).then((retweet) => {
                onAdd && onAdd(retweet);
                this.setState({publishing: false});
                ToastService.success(`${label} Successful`);
              }).catch((e) => {
                if (e.message) {
                  ToastService.error("Failed to submit", e.message);
                } else {
                  ToastService.error(`Failed to ${label}`);
                }
              });
            }}>
            {label}
          </button>
        </div>
      </div>
    );
  }
});
